import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaApp } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)
Vue.use(PortalVue)
Vue.use(VueMeta)

InertiaProgress.init()

let app = document.getElementById('app')

Vue.filter('toEUR', function (value) {
    if (!value) return ''
    return parseFloat(value).toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.');
})

new Vue({
  metaInfo: {
    titleTemplate: (title) => title ? `${title} - Monospark CRM` : 'Monospark CRM'
  },
  render: h => h(InertiaApp, {
    props: {
      initialPage: JSON.parse(app.dataset.page),
      resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
    },
  }),
}).$mount(app)
